export const getDefaultLocale = () => {
  const browserLanguages = navigator.languages?.map((l) => l.split('-')[0]) || [];
  return browserLanguages.includes('pl') ? 'pl' : 'en';
};
